export const TEST_BASIC_10_PRICING_FLAG = 'test_pro_basic_10_pricing_fly4076_230825';
export const TEST_BASIC_10_PRICING_PERCENT = 0.5;

export const PROVIDER_SIGNUP_VERSION_PAGE_SWITCH = 'pro_onboarding_flow_fly3702_20230607';
export const ONBOARDING_CONTINUE_LATER_SWITCH = 'pro_onboarding_continue_fly4054_20230804';
export const PROVIDER_HOME_NEXT_BEST_ACTIONS_FLAG = 'pro_home_next_best_actions_fly4058_20230830';
